import { AppThunk } from "services/redux/rootReducer";
import { getDataFromRequest } from "services/axios/utility/helper";
import { ENDPOINT } from "services/axios/constants/endpoints";
import { HTTPMethods } from "services/axios/types/http";
import { getToken } from "features/auth/functions/token";

const triggerBackup =
    (collections: string[]): AppThunk<Promise<void>> =>
    async () => {
        return await getDataFromRequest(
            ENDPOINT.FUNCTIONS_API.BACKUPS.TRIGGER,
            HTTPMethods.POST,
            getToken(),
            {
                collections,
            }
        );
    };

export default triggerBackup;
